// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-top-header {
  border-bottom: 1px solid #000;
}

.report-top-header-text {
  color: #000;
  font-weight: 500;
  font-size: 18px;
}

.report-listing-header {
  color: #000;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
}

.report-listing {
  background-color: #f6faff;
  border: 1px solid #d8e8ff;
  color: #485568;
  cursor: pointer;
}

.report-listing-listgroup {
  border-radius: 0;
}

.job-details-listgroup {
  border: 1px solid #43246C;
  border-radius: 0;
}

.job-details-listgroupitem {
  background-color: #F3EEF9;
  border: 0;
  color: #1C1C1C;
  cursor: pointer;
}

.job-details-listgroupitem-border-bottom {
  border-bottom: 1px solid #43246C;
}

.report-listing-selected {
  background-color: #0a56ae;
  color: white;
  border: 1px solid #0a56ae;
}

.job-details-selected {
  background-color: white;
  color: #43246C;
  border: none;
}

.report-listing-count {
  color: #0a56ae;
  font-weight: 500;
  font-size: 13px;
}

.report-listing-count-selected {
  color: #fff;
  font-weight: 500;
}

.job-details-count-selected {
  color: #43246C;
  font-weight: 500;
}

.report-listing-border {
  border: 1px solid #bababa;
}

.report-listing-filter-btn {
  border: 1px solid #bababa;
  background-color: #fff;
}

.report-listing-filter-btn:hover {
  border: 1px solid #95b5da;
  background-color: #fff;
}

.report-listing-filter-btn:mousedown {
  background-color: #fff;
}

.report-cols {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2rem;
  width: 34%;
  height: 120vh;
}

.report-date-preview {
  background-color: #fff;
  border: 1px solid #bababa;
  padding: 7px;
  border-radius: 5px;
  cursor: pointer;
}

.report-date-cancel,
.report-date-clear {
  background-color: #fff;
  color: #000;
  border: 1px solid #bababa;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 9px;
  padding-right: 9px;
}

.report-date-vr {
  display: inline;
  border-left: 1px solid #bababa;
  height: 370px;
}

.report-date-hr {
  display: inline;
  border-top: 1px solid #bababa;
  width: 500px;
}

.report-date-done {
  background-color: #0a56ae;
  color: #fff;
  border: 1px solid #0a56ae;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 9px;
  padding-right: 9px;
}

.report-date-btn {
  cursor: pointer;
  background-color: #fff;
  color: #000;
  border: none;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 5px;
}

.report-date-btn:hover {
  background-color: #e0edff;
  border: 1px solid #495cff;
  transition: 0.8s;
}

.report-date-btn:focus {
  background-color: #e0edff;
  border: 1px solid #4550ae;
  color: black;
}

.report-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.date-pre-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.report-date-cancel:hover,
.report-date-clear:hover,
.report-date-done:hover {
  background-color: #f6faff;
  border: 1px solid #bababa;
  transition: 0.3s;
}

@media (min-width: 1024px) {
  .report-cols {
    height: 170vh;
  }

  .report-content,
.report-listing-count,
.report-date-done,
.report-date-cancel,
.report-date-clear,
.report-date-preview-inner,
.report-date-btn {
    font-size: 11px;
  }

  .report-listing {
    height: 38px;
  }

  .report-listing-header {
    font-size: 13.5px;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 5px;
  }

  .job-cv-subtitle {
    padding-left: 2px;
    font-size: 12px;
    color: #0a56ae;
  }

  .report-top-header-text {
    font-size: 16px;
  }

  .report-date-vr {
    height: 335px;
  }
}
@media (min-width: 1366px) {
  .report-cols {
    height: 160vh;
  }

  .report-content,
.report-listing-count,
.report-date-done,
.report-date-cancel,
.report-date-clear,
.report-date-preview-inner,
.report-date-btn {
    font-size: 13px;
  }

  .report-listing {
    height: 45px;
  }

  .report-listing-header {
    font-size: 15px;
  }

  .report-top-header-text {
    font-size: 18px;
  }

  .report-date-vr {
    height: 370px;
  }
}
@media (min-width: 1920px) {
  .report-cols {
    height: 120vh;
    gap: 1rem;
  }

  .report-date-vr {
    height: 370px;
  }
}`, "",{"version":3,"sources":["webpack://./../report/src/components/UniversalReport/UniversalReport.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,6BAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;;;EAGE,yBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAGA;EACE;IACE,aAAA;EAAF;;EAGA;;;;;;;IAOE,eAAA;EAAF;;EAGA;IACE,YAAA;EAAF;;EAGA;IACE,iBAAA;IACA,aAAA;IACA,mBAAA;IACA,qBAAA;IACA,QAAA;EAAF;;EAGA;IACE,iBAAA;IACA,eAAA;IACA,cAAA;EAAF;;EAGA;IACE,eAAA;EAAF;;EAGA;IACE,aAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;EADF;;EAIA;;;;;;;IAOE,eAAA;EADF;;EAIA;IACE,YAAA;EADF;;EAIA;IACE,eAAA;EADF;;EAIA;IACE,eAAA;EADF;;EAIA;IACE,aAAA;EADF;AACF;AAIA;EACE;IACE,aAAA;IACA,SAAA;EAFF;;EAKA;IACE,aAAA;EAFF;AACF","sourcesContent":[".report-top-header {\n  border-bottom: 1px solid #000;\n}\n\n.report-top-header-text {\n  color: #000;\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.report-listing-header {\n  color: #000;\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.report-listing {\n  background-color: #f6faff;\n  border: 1px solid #d8e8ff;\n  color: #485568;\n  cursor: pointer;\n}\n\n.report-listing-listgroup {\n  border-radius: 0;\n}\n\n.job-details-listgroup {\n  border: 1px solid #43246C;\n  border-radius: 0;\n}\n\n.job-details-listgroupitem {\n  background-color: #F3EEF9;\n  border: 0;\n  color: #1C1C1C;\n  cursor: pointer;\n}\n\n.job-details-listgroupitem-border-bottom {\n  border-bottom: 1px solid #43246C;\n}\n\n.report-listing-selected {\n  background-color: #0a56ae;\n  color: white;\n  border: 1px solid #0a56ae;\n}\n\n.job-details-selected {\n  background-color: white;\n  color: #43246C;\n  border: none;\n}\n\n.report-listing-count {\n  color: #0a56ae;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.report-listing-count-selected {\n  color: #fff;\n  font-weight: 500;\n}\n\n.job-details-count-selected {\n  color: #43246C;\n  font-weight: 500;\n}\n\n.report-listing-border {\n  border: 1px solid #bababa;\n}\n\n.report-listing-filter-btn {\n  border: 1px solid #bababa;\n  background-color: #fff;\n}\n\n.report-listing-filter-btn:hover {\n  border: 1px solid #95b5da;\n  background-color: #fff;\n}\n\n.report-listing-filter-btn:mousedown {\n  background-color: #fff;\n}\n\n.report-cols {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 2rem;\n  width: 34%;\n  height: 120vh;\n}\n\n.report-date-preview {\n  background-color: #fff;\n  border: 1px solid #bababa;\n  padding: 7px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.report-date-cancel,\n.report-date-clear {\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #bababa;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 9px;\n  padding-right: 9px;\n}\n\n.report-date-vr {\n  display: inline;\n  border-left: 1px solid #bababa;\n  height: 370px;\n}\n\n.report-date-hr {\n  display: inline;\n  border-top: 1px solid #bababa;\n  width: 500px;\n}\n\n.report-date-done {\n  background-color: #0a56ae;\n  color: #fff;\n  border: 1px solid #0a56ae;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 9px;\n  padding-right: 9px;\n}\n\n.report-date-btn {\n  cursor: pointer;\n  background-color: #fff;\n  color: #000;\n  border: none;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 9px;\n  padding-right: 9px;\n  border-radius: 5px;\n}\n\n.report-date-btn:hover {\n  background-color: #e0edff;\n  border: 1px solid #495cff;\n  transition: 0.8s;\n}\n\n.report-date-btn:focus {\n  background-color: #e0edff;\n  border: 1px solid #4550ae;\n  color: black;\n}\n\n.report-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.date-pre-selector {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.report-date-cancel:hover,\n.report-date-clear:hover,\n.report-date-done:hover {\n  background-color: #f6faff;\n  border: 1px solid #bababa;\n  transition: 0.3s;\n}\n\n\n@media (min-width: 1024px) {\n  .report-cols {\n    height: 170vh;\n  }\n\n  .report-content,\n  .report-listing-count,\n  .report-date-done,\n  .report-date-cancel,\n  .report-date-clear,\n  .report-date-preview-inner,\n  .report-date-btn {\n    font-size: 11px;\n  }\n\n  .report-listing {\n    height: 38px;\n  }\n\n  .report-listing-header {\n    font-size: 13.5px;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 5px;\n  }\n\n  .job-cv-subtitle {\n    padding-left: 2px;\n    font-size: 12px;\n    color: #0a56ae;\n  }\n\n  .report-top-header-text {\n    font-size: 16px;\n  }\n\n  .report-date-vr {\n    height: 335px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .report-cols {\n    height: 160vh;\n  }\n\n  .report-content,\n  .report-listing-count,\n  .report-date-done,\n  .report-date-cancel,\n  .report-date-clear,\n  .report-date-preview-inner,\n  .report-date-btn {\n    font-size: 13px;\n  }\n\n  .report-listing {\n    height: 45px;\n  }\n\n  .report-listing-header {\n    font-size: 15px;\n  }\n\n  .report-top-header-text {\n    font-size: 18px;\n  }\n\n  .report-date-vr {\n    height: 370px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .report-cols {\n    height: 120vh;\n    gap: 1rem;\n  }\n\n  .report-date-vr {\n    height: 370px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
